import FileInfo from '../containers/FileInfo';

async function listDirectoryChildItems(f_id: number) {
  const path = '/api/asebi/fileinfos/{f_id}/children'.replace('{f_id}', f_id.toString());
  const resp = await fetch(path);
  const json = await resp.json();

  return json.map((data: any) => {
    const f = new FileInfo();
    f.load(data);
    return f;
  });
}

export default listDirectoryChildItems;
